import type { NomePerfil } from "@/types";

export type Permission =
  | "visualizar"
  | "cadastrar"
  | "editar"
  | "movimentar"
  | "emprestar"
  | "manter"
  | "inventariar"
  | "relatorios"
  | "compras"
  | "excluir"
  | "auditoria"
  | "usuarios"
  | "configuracoes"
  | "equipamentos_criar"
  | "equipamentos_importar"
  | "equipamentos_editar"
  | "equipamentos_transferir"
  | "equipamentos_vincular"
  | "equipamentos_baixar"
  | "suprimentos_criar"
  | "suprimentos_editar"
  | "suprimentos_entrada"
  | "suprimentos_saida"
  | "suprimentos_transferir"
  | "movimentacoes_registrar"
  | "movimentacoes_transferir"
  | "movimentacoes_aprovar"
  | "movimentacoes_estornar"
  | "movimentacoes_configurar"
  | "colaboradores_criar"
  | "colaboradores_editar"
  | "colaboradores_entregar"
  | "colaboradores_devolver"
  | "colaboradores_transferir"
  | "colaboradores_afastar"
  | "colaboradores_desligar"
  | "colaboradores_reativar"
  | "colaboradores_documentos"
  | "colaboradores_dados_pessoais"
  | "colaboradores_termos"
  | "inventarios_criar"
  | "inventarios_editar"
  | "inventarios_preparar"
  | "inventarios_iniciar"
  | "inventarios_conferir"
  | "inventarios_revisar"
  | "inventarios_aprovar"
  | "inventarios_finalizar"
  | "inventarios_cancelar"
  | "inventarios_exportar"
  | "inventarios_documentos"
  | "inventarios_auditoria";

const profilePermissions: Record<NomePerfil, Permission[]> = {
  Administrador: [
    "visualizar", "cadastrar", "editar", "movimentar", "emprestar", "manter",
    "inventariar", "relatorios", "compras", "excluir", "auditoria", "usuarios", "configuracoes",
    "equipamentos_criar", "equipamentos_importar", "equipamentos_editar", "equipamentos_transferir",
    "equipamentos_vincular", "equipamentos_baixar",
    "suprimentos_criar", "suprimentos_editar", "suprimentos_entrada",
    "suprimentos_saida", "suprimentos_transferir",
    "movimentacoes_registrar", "movimentacoes_transferir", "movimentacoes_aprovar",
    "movimentacoes_estornar", "movimentacoes_configurar",
    "colaboradores_criar", "colaboradores_editar", "colaboradores_entregar",
    "colaboradores_devolver", "colaboradores_transferir", "colaboradores_afastar",
    "colaboradores_desligar", "colaboradores_reativar", "colaboradores_documentos",
    "colaboradores_dados_pessoais", "colaboradores_termos",
    "inventarios_criar", "inventarios_editar", "inventarios_preparar", "inventarios_iniciar",
    "inventarios_conferir", "inventarios_revisar", "inventarios_aprovar", "inventarios_finalizar",
    "inventarios_cancelar", "inventarios_exportar", "inventarios_documentos", "inventarios_auditoria",
  ],
  "Gestor de TI": [
    "visualizar", "cadastrar", "editar", "movimentar", "emprestar", "manter",
    "inventariar", "relatorios", "compras", "equipamentos_criar", "equipamentos_importar",
    "equipamentos_editar", "equipamentos_transferir", "equipamentos_vincular",
    "equipamentos_baixar",
    "suprimentos_criar", "suprimentos_editar", "suprimentos_entrada",
    "suprimentos_saida", "suprimentos_transferir",
    "movimentacoes_registrar", "movimentacoes_transferir", "movimentacoes_aprovar",
    "movimentacoes_estornar",
    "colaboradores_criar", "colaboradores_editar", "colaboradores_entregar",
    "colaboradores_devolver", "colaboradores_transferir", "colaboradores_afastar",
    "colaboradores_desligar", "colaboradores_documentos", "colaboradores_termos",
    "inventarios_criar", "inventarios_editar", "inventarios_preparar", "inventarios_iniciar",
    "inventarios_conferir", "inventarios_revisar", "inventarios_aprovar", "inventarios_finalizar",
    "inventarios_cancelar", "inventarios_exportar", "inventarios_documentos",
  ],
  "Técnico de TI": [
    "visualizar", "movimentar", "manter", "emprestar", "inventariar",
    "equipamentos_criar", "equipamentos_editar", "equipamentos_transferir",
    "equipamentos_vincular",
    "suprimentos_entrada", "suprimentos_saida",
    "movimentacoes_registrar", "colaboradores_entregar", "colaboradores_devolver",
    "colaboradores_transferir", "colaboradores_termos",
    "inventarios_conferir", "inventarios_documentos", "inventarios_exportar",
  ],
  Consulta: ["visualizar", "relatorios", "inventarios_exportar"],
};

export function getPermissions(profile?: NomePerfil | null): Permission[] {
  return profile ? profilePermissions[profile] : [];
}
